import React from 'react';
import { SlidersHorizontal, CreditCard } from 'lucide-react';
type Tab = 'management' | 'subscription';
interface BottomNavProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const tabs = [{
    id: 'management' as Tab,
    icon: SlidersHorizontal,
    label: 'Управление'
  }, {
    id: 'subscription' as Tab,
    icon: CreditCard,
    label: 'Подписка'
  }];
  return <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[500px] bg-svt-card/80 backdrop-blur-xl border-t border-svt-border z-50 transition-colors duration-300" data-id="element-41">
      <div className="flex items-center justify-around px-4 py-3" data-id="element-42">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onTabChange(tab.id)} className="flex flex-col items-center gap-1 flex-1 relative group" data-id="element-43">
              <div className={`p-2 rounded-xl transition-all duration-300 ${isActive ? 'bg-gradient-primary text-white shadow-[0_0_20px_rgba(232,67,147,0.4)]' : 'text-svt-text-muted group-hover:text-svt-text'}`} data-id="element-44">
                <Icon size={20} data-id="element-45" />
              </div>
              <span className={`text-xs font-medium transition-colors ${isActive ? 'text-svt-pink-light' : 'text-svt-text-faint'}`} data-id="element-46">
                {tab.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}